import type {RoomWithRequiredExposure} from "./get_only_rooms_with_exposure";

export const groupRoomsByExposure = (rooms: RoomWithRequiredExposure[]) => {
    return rooms.reduce(
        (acc, room) => {
            // sort to make sure that [S, E] means the same as [E, S]
            const exposureKey = [...room.exposure].sort().join(",");
            acc[exposureKey] = acc[exposureKey] ? [...acc[exposureKey], room] : [room];

            return acc;
        },
        {} as Record<string, RoomWithRequiredExposure[]>
    );
};
import type {RoomWithRequiredExposure} from "./get_only_rooms_with_exposure";

export const groupRoomsByExposure = (rooms: RoomWithRequiredExposure[]) => {
    return rooms.reduce(
        (acc, room) => {
            // sort to make sure that [S, E] means the same as [E, S]
            const exposureKey = [...room.exposure].sort().join(",");
            acc[exposureKey] = acc[exposureKey] ? [...acc[exposureKey], room] : [room];

            return acc;
        },
        {} as Record<string, RoomWithRequiredExposure[]>
    );
};
